import axios, {
  AxiosError,
  AxiosRequestConfig,
  RawAxiosRequestHeaders,
} from 'axios';
import { toast } from 'react-toastify';

const validateStatus = (status: number) => status === 200;

/**
 * Stuur de Authorization-header alleen mee als er echt een token is. Zonder deze conditie
 * gaat er bij een niet-ingelogd verzoek een lege `Bearer `-header mee. Dat is onschadelijk
 * (Laravel behandelt een lege bearer-token als "geen token"), maar het verhult de bedoeling.
 * `RawAxiosRequestHeaders` is een Partial, dus een leeg object mag; het `AxiosRequestHeaders`
 * uit axios 0.x is dat niet meer.
 */
const authHeaders = (accessToken: string): RawAxiosRequestHeaders =>
  accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

/** @see https://axios-http.com/docs/handling_errors */
const errorHandler = (error: AxiosError) => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    toast.error(
      `Error ${error.response.status}: ${
        // @ts-expect-error data is not defined on AxiosError
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        error.response.data.message ?? 'Unknown error'
      }`
    );
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.error(error.request);
  }
};
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class HttpService {
  static get<T>(
    endpoint: string,
    accessToken = '',
    config?: AxiosRequestConfig
  ) {
    return axios.get<T>(endpoint, {
      headers: authHeaders(accessToken),
      validateStatus,
      ...config,
    });
  }

  static post<T, D = unknown>(endpoint: string, data: D, accessToken = '') {
    return axios.post<T>(endpoint, data, {
      headers: authHeaders(accessToken),
      validateStatus,
    });
  }
}

export default HttpService;
export { errorHandler };
